import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import {
  AssistantCoach,
  AssistantCoachCreateParams,
  AssistantCoachUpdateParams,
  AssistantCoachFilterParams,
  AssistantCoachPlayersParams,
  ExtraAssistantCoachFields,
} from "./dtos/AssistantCoach";
import { Page, Player } from "@/services/bedrock/dtos";

const ASSISTANT_COACH_SERVICE = `${Constants.API_URL}/bedrock/assistant_coaches`;

export class AssistantCoachServices {
  @scCatchServiceException()
  static async getAssistantCoaches(params?: AssistantCoachFilterParams): Promise<Page<AssistantCoach>> {
    const { data } = await axios.get<Page<AssistantCoach>>(ASSISTANT_COACH_SERVICE, { params });
    return data;
  }

  @scCatchServiceException()
  static async getAssistantCoach(
    id: string | number,
    params?: { extraFields?: ExtraAssistantCoachFields | ExtraAssistantCoachFields[] }
  ): Promise<AssistantCoach> {
    const { data } = await axios.get<AssistantCoach>(`${ASSISTANT_COACH_SERVICE}/${id}`, { params });
    return data;
  }

  @scCatchServiceException()
  static async createAssistantCoach(params: AssistantCoachCreateParams): Promise<AssistantCoach> {
    const { data } = await axios.post<AssistantCoach>(ASSISTANT_COACH_SERVICE, params);
    return data;
  }

  @scCatchServiceException()
  static async updateAssistantCoach(id: string | number, params: AssistantCoachUpdateParams): Promise<AssistantCoach> {
    const { data } = await axios.patch<AssistantCoach>(`${ASSISTANT_COACH_SERVICE}/${id}`, params);
    return data;
  }

  @scCatchServiceException()
  static async getAssistantCoachPlayers(
    id: string | number,
    params?: AssistantCoachPlayersParams
  ): Promise<Page<Player>> {
    const { data } = await axios.get<Page<Player>>(`${ASSISTANT_COACH_SERVICE}/${id}/players`, { params });
    return data;
  }

  @scCatchServiceException()
  static async deactivateAssistantCoach(id: string | number): Promise<AssistantCoach> {
    const { data } = await axios.post<AssistantCoach>(`${ASSISTANT_COACH_SERVICE}/${id}/deactivate`);
    return data;
  }

  @scCatchServiceException()
  static async activateAssistantCoach(id: string | number): Promise<AssistantCoach> {
    const { data } = await axios.post<AssistantCoach>(`${ASSISTANT_COACH_SERVICE}/${id}/activate`);
    return data;
  }
}
